import React from 'react';
import DirectoryListingCollapse from "./directory/DirectoryListingCollapse";

const Directory = (props) => {
    return (
        <DirectoryListingCollapse />
    );
}

export default Directory;